import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createFarmLivestock } from "services";

import { CREATE_FARM_LIVESTOCK, GET_FARM_LIVESTOCK } from "consts";

export const useCreateFarmLivestock = ({ farmId }: { farmId: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [CREATE_FARM_LIVESTOCK, farmId],
    mutationFn: createFarmLivestock,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_LIVESTOCK, farmId, variables.year] });
    },
  });
};
